// Module
var code = "<div class=\"metric-box\"> <div class=\"text\">{{ $ctrl.text }}</div> <div class=\"value\">{{ $ctrl.value }}</div> <div class=\"subtitle\">{{ $ctrl.subtitle }}</div> </div> ";
// Exports
export default code;